import React from 'react';
import styled from 'styled-components';

import AboutUs from './AboutUs';
import CovidInfoBox from './CovidInfoBox';
import Revisit from './Revisit';
import TechLeaders from './TechLeaders';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;

const BodyTwo = () => {
  return (
    <Wrapper>
      <CovidInfoBox />
      <AboutUs />
      <TechLeaders />
      <Revisit />
    </Wrapper>
  );
};

export default BodyTwo;
